import React from 'react'

interface TagBadgeProps {
  tag: string
  onClick?: (tag: string) => void
  size?: 'sm' | 'md'
}

export const TagBadge: React.FC<TagBadgeProps> = ({ tag, onClick, size = 'md' }) => {
  const isSm = size === 'sm'

  const handleClick = () => {
    if (onClick) onClick(tag)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      if (onClick) onClick(tag)
    }
  }

  return (
    <>
      <style>{`
        .tag-badge {
          display: inline-flex;
          align-items: center;
          background-color: var(--tag-bg);
          color: var(--tag-color);
          border: 0.5px solid var(--tag-border);
          border-radius: var(--radius-sm, 4px);
          font-family: 'JetBrains Mono', 'Courier New', monospace;
          cursor: default;
          transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
          white-space: nowrap;
          letter-spacing: 0.01em;
        }
        .tag-badge.clickable {
          cursor: pointer;
        }
        .tag-badge.clickable:hover {
          background-color: var(--accent-teal);
          color: #1a1a18;
          border-color: var(--accent-teal);
        }
        .tag-badge.clickable:focus-visible {
          outline: 2px solid var(--accent-blue);
          outline-offset: 2px;
        }
        .tag-badge-sm {
          font-size: 0.68rem;
          padding: 2px 7px;
        }
        .tag-badge-md {
          font-size: 0.73rem;
          padding: 3px 9px;
        }
        .tag-hash {
          color: var(--accent-teal);
          margin-right: 1px;
          opacity: 0.7;
        }
        .tag-badge.clickable:hover .tag-hash {
          color: #1a1a18;
          opacity: 1;
        }
      `}</style>
      <span
        className={`tag-badge ${isSm ? 'tag-badge-sm' : 'tag-badge-md'} ${onClick ? 'clickable' : ''}`}
        onClick={onClick ? handleClick : undefined}
        onKeyDown={onClick ? handleKeyDown : undefined}
        tabIndex={onClick ? 0 : undefined}
        role={onClick ? 'button' : undefined}
        aria-label={onClick ? `Filter by tag ${tag}` : undefined}
      >
        <span className="tag-hash">#</span>
        {tag}
      </span>
    </>
  )
}
